/**
 * The stored cookie choice, read without React.
 *
 * Lives apart from `CookieConsent.jsx` (which re-exports these) so `track.js`
 * can ask "is analytics allowed?" without importing the banner — and so the
 * banner can tell `track.js` about a change without the two importing each
 * other.
 */
export const CONSENT_STORAGE_KEY = "zatoplan_cookie_consent";

/**
 * Get stored cookie consent preferences
 * @returns {Object|null} Consent preferences or null if not set
 */
export const getCookieConsent = () => {
  try {
    const stored = localStorage.getItem(CONSENT_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

/**
 * Check if analytics cookies are allowed
 * @returns {boolean}
 */
export const isAnalyticsAllowed = () => getCookieConsent()?.analytics === true;

/**
 * Check if marketing cookies are allowed
 * @returns {boolean}
 */
export const isMarketingAllowed = () => getCookieConsent()?.marketing === true;
